import { SerializableObject } from './serializable-object';


/**
 * The organization's ERP connection credentials.
 */
export class ErpCredentials extends SerializableObject {
  public AdminAuthenticate?: boolean;
  public CompanyId: string;
  public KeepPassword?: string;
  public Password: string;
  public Username: string;
}
